import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthIconNavigationConverter extends CmsConverterService<FullWidthIconNavigationData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const FULL_WIDTH_ICON_NAVIGATION_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CmsComponent>>('FullWidthIconNavigationConverter')

export type FullWidthIconNavigationData = ConvertedComponentData
